module.exports = __webpack_public_path__ + "static/assets/2361d11ac88b5b0b2f2f2972e98aec10.png";